import React, {Component} from 'react';
import { compose, withProps } from "recompose";
import {GoogleMap, Marker, withScriptjs, withGoogleMap, Polygon} from 'react-google-maps';

export class Displaymap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapInfo: this.props.mapDetails,
            propertyInfo: this.props.propDetails,
            defaultZoom: 18,
            defaultCenter: {lat: -27.452754, lng: 153.038329},
            defaultPoly: [{lng: 153.0382,lat: -27.45288}, {lng: 153.03763,lat: -27.45244}, 
                {lng: 153.03802,lat: -27.45204}, {lng: 153.03857, lat: -27.45249}, 
                {lng: 153.0382,lat: -27.45288}]
        }
    } 
    
    _propertyDetails () {
        if (this.state.mapInfo.Map != null) {
            //console.log(JSON.stringify(this.state.mapInfo.Map,4));
            if (this.state.mapInfo.Map.Centroid != null) {
                this.setState ({
                    defaultCenter: {lat: this.state.mapInfo.Map.Centroid.Latitude, lng: this.state.mapInfo.Map.Centroid.Longitude},
                    defaultZoom: 19
                });
            }

            if (Object.keys(this.state.propertyInfo.Map.MapLayers).length != 0) {
                //console.log(JSON.stringify(this.state.propertyInfo.Map.MapLayers,4));
                console.log(Object.keys(this.state.propertyInfo.Map.MapLayers).length);
                let propPoly=[];
                if (this.state.propertyInfo.Map.MapLayers[0].Polygons[0] != null) {
                    for (var polyPoint in this.state.propertyInfo.Map.MapLayers[0].Polygons[0].PolygonPoints)
                    if (this.state.propertyInfo.Map.MapLayers[0].Polygons[0].PolygonPoints.hasOwnProperty(polyPoint)) {
                        var t = this.state.propertyInfo.Map.MapLayers[0].Polygons[0].PolygonPoints[polyPoint].Latitude
                        , n = this.state.propertyInfo.Map.MapLayers[0].Polygons[0].PolygonPoints[polyPoint].Longitude;
                        propPoly.push({lat: t, lng: n });
                    }
                    //console.log(propPoly);
                    this.setState ({defaultPoly: propPoly});
                }
            }
        }
    }
    
    componentDidMount (){
        this._propertyDetails();
    }

    render () {
        const AppMap = compose(
            withProps({
                googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAmYm3QTixzGXcjFVE73-qGfpSNoOurCmQ&v=3.exp&libraries=geometry,drawing,places",
                loadingElement: <div style={{ height: `100%` }} />,
                containerElement: <div style={{ height: `400px` }} />,
                mapElement: <div style={{ height: `100%` }} />,
            }),
            withScriptjs,
            withGoogleMap
          )((props) => 
                <GoogleMap
                    defaultZoom={this.state.defaultZoom}
                    defaultCenter={this.state.defaultCenter}
                >
                    <Marker position={this.state.defaultCenter} />
                    <Polygon paths={this.state.defaultPoly} options={{
                        strokeColor: "#FF0000",
                        strokeOpacity: .8,
                        strokeWeight: 2,
                        fillColor: "#FF0000",
                        fillOpacity: .35
                    }} />
                </GoogleMap>
        );

            return (
                <div>
                    <AppMap />
                </div>
            )
    }
}

export default Displaymap;




// WEBPACK FOOTER //
// ./src/Displaymap.js